var _g, _g2, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _polygon2, _path7, _path8, _path9, _path0, _path1, _path10, _g3, _polygon3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g4, _polygon4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _polygon5, _polygon6, _path27, _path28, _path29, _path30, _path31, _path32, _g5, _g6, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _circle, _circle2, _circle3, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _polygon7, _polygon8, _g7, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDc31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.03 445.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor-2",
    "data-name": "Floor",
    cx: 238.51,
    cy: 303.33,
    rx: 238.01,
    ry: 141.59,
    fill: "none",
    stroke: "#f5f5f5",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.54,438.81l.11-.13,5.92-6.5v0l0-.05a.57.57,0,0,1,.11-.11l.06-.07h0c.85-.81,2.19-.88,3.7,0a10.23,10.23,0,0,1,4.64,8c0,1.72-.7,2.84-1.79,3.19h0l-.07,0a1.94,1.94,0,0,1-.33.07l-.08,0h0l-8.57,1.87a2.16,2.16,0,0,1-1.5-.33,5.86,5.86,0,0,1-2.65-4.59A2.22,2.22,0,0,1,242.54,438.81Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Books"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Books-2",
    "data-name": "Books"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Book"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "429.26 247.11 359.67 286.4 252.8 225.08 322.39 185.78 429.26 247.11",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.26 247.11 359.67 286.4 252.8 225.08 322.39 185.78 429.26 247.11",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.4,327.17,437.65,289c-1.67-4.74-1.55-6.18.35-12.49l-66.84,37.82S369.94,314.2,370.4,327.17Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.42,309.11a13.47,13.47,0,0,0-6.14,10.57V328c0,3.9,2.75,5.47,6.14,3.53l66.32-37.68v-3.06l-65.48,37c-2,1.16-3.69.22-3.68-2.12l.05-7.36a8.12,8.12,0,0,1,3.7-6.35l65.4-37v-3.47Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.42,309.11a13.47,13.47,0,0,0-6.14,10.57V328c0,3.9,2.75,5.47,6.14,3.53l66.32-37.68v-3.06l-65.48,37c-2,1.16-3.69.22-3.68-2.12l.05-7.36a8.12,8.12,0,0,1,3.7-6.35l65.4-37v-3.47Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440.74,271.44,333.87,210.11l-66.32,37.67a13.5,13.5,0,0,0-6.14,10.58v8.27c0,1.94.68,3.31,1.8,3.95L370.08,331.9c-1.12-.64-1.8-2-1.8-3.94v-8.28a13.5,13.5,0,0,1,6.14-10.58Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.74,271.44,333.87,210.11l-66.32,37.67a13.5,13.5,0,0,0-6.14,10.58v8.27c0,1.94.68,3.31,1.8,3.95L370.08,331.9c-1.12-.64-1.8-2-1.8-3.94v-8.28a13.5,13.5,0,0,1,6.14-10.58Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.35,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M370.07,313.66a12.46,12.46,0,0,0-1.8,6V328c0,1.94.68,3.31,1.8,3.95L263.21,270.58c-1.12-.65-1.8-2-1.8-3.95v-8.27a12.46,12.46,0,0,1,1.8-6Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.07,313.66a12.46,12.46,0,0,0-1.8,6V328c0,1.94.68,3.31,1.8,3.95L263.21,270.58c-1.12-.65-1.8-2-1.8-3.95v-8.27a12.46,12.46,0,0,1,1.8-6Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.45,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M277.65,260.54c-2,8.65-2,12,0,18.37l5.08,2.94c-2-6.34-2-9.72,0-18.37Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M347.74,300.82c-2,8.65-2,11.92,0,18.26l5.09,2.94c-2-6.35-2-9.62,0-18.26Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Book-2",
    "data-name": "Book"
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "443.3 226.77 373.71 266.07 266.84 204.75 336.43 165.44 443.3 226.77",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "443.3 226.77 373.71 266.07 266.84 204.75 336.43 165.44 443.3 226.77",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M384.44,306.83l67.25-38.2c-1.67-4.74-1.55-6.86.34-13.17L385.2,293.27S384,293.86,384.44,306.83Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M388.46,288.09a13.52,13.52,0,0,0-6.15,10.58v8.95c0,3.89,2.76,5.47,6.15,3.52l66.32-37.67v-3.06l-65.48,37c-2,1.17-3.69.22-3.69-2.11l.06-8.05a8.11,8.11,0,0,1,3.69-6.34l65.41-37v-3.47Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.46,288.09a13.52,13.52,0,0,0-6.15,10.58v8.95c0,3.89,2.76,5.47,6.15,3.52l66.32-37.67v-3.06l-65.48,37c-2,1.17-3.69.22-3.69-2.11l.06-8.05a8.11,8.11,0,0,1,3.69-6.34l65.41-37v-3.47Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M454.78,250.43,347.91,189.1l-66.32,37.67a13.47,13.47,0,0,0-6.14,10.58v9c0,1.94.68,3.3,1.8,3.94l106.87,61.33c-1.12-.64-1.8-2-1.8-3.95v-8.95a13.47,13.47,0,0,1,6.14-10.58Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M384.11,292.65a12.43,12.43,0,0,0-1.8,6v8.95c0,1.94.68,3.31,1.8,3.95L277.25,250.24c-1.12-.64-1.8-2-1.8-3.94v-9a12.43,12.43,0,0,1,1.8-6Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.11,292.65a12.43,12.43,0,0,0-1.8,6v8.95c0,1.94.68,3.31,1.8,3.95L277.25,250.24c-1.12-.64-1.8-2-1.8-3.94v-9a12.43,12.43,0,0,1,1.8-6Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M291.68,239.52c-2,8.65-2,12.72,0,19.06l5.09,2.94c-2-6.35-2-10.41,0-19.06Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M361.78,279.85c-2,8.65-2,12.57,0,18.91l5.09,2.94c-2-6.34-2-10.29,0-18.94Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.68,239.52c-2,8.65-2,12.72,0,19.06l5.09,2.94c-2-6.35-2-10.41,0-19.06Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.78,279.85c-2,8.65-2,12.57,0,18.91l5.09,2.94c-2-6.34-2-10.29,0-18.94Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Books-3",
    "data-name": "Books"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Book-3",
    "data-name": "Book"
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "67.01 334.77 175.1 396.18 331.89 306.19 223.81 244.77 67.01 334.77",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "67.01 334.77 175.1 396.18 331.89 306.19 223.81 244.77 67.01 334.77",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.4,436.75,81.81,376.51c1.79-5.07,1.65-7.34-.37-14.08l105.15,59.83S187.89,422.89,187.4,436.75Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183.1,416.72a14.4,14.4,0,0,1,6.57,11.3v9.56c0,4.17-2.94,5.85-6.57,3.77L78.51,381.68v-3.27l103.7,58.91c2.17,1.25,3.93.24,3.93-2.26l-.06-8.59a8.65,8.65,0,0,0-3.94-6.78L78.51,360.75v-3.7Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.1,416.72a14.4,14.4,0,0,1,6.57,11.3v9.56c0,4.17-2.94,5.85-6.57,3.77L78.51,381.68v-3.27l103.7,58.91c2.17,1.25,3.93.24,3.93-2.26l-.06-8.59a8.65,8.65,0,0,0-3.94-6.78L78.51,360.75v-3.7Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.51,357.05l156.78-90,104.59,59.67a14.4,14.4,0,0,1,6.57,11.3v9.56c0,2.08-.73,3.54-1.92,4.22l-156.79,90c1.19-.68,1.92-2.15,1.93-4.22V428a14.42,14.42,0,0,0-6.57-11.3Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.51,357.05l156.78-90,104.59,59.67a14.4,14.4,0,0,1,6.57,11.3v9.56c0,2.08-.73,3.54-1.92,4.22l-156.79,90c1.19-.68,1.92-2.15,1.93-4.22V428a14.42,14.42,0,0,0-6.57-11.3Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187.75,421.59a13.25,13.25,0,0,1,1.93,6.43v9.57c0,2.07-.74,3.54-1.93,4.22l156.79-90c1.19-.69,1.92-2.15,1.92-4.22V338a13.28,13.28,0,0,0-1.93-6.43Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.75,421.59a13.34,13.34,0,0,1,1.92,6.43v9.57c0,2.07-.73,3.53-1.92,4.22l156.78-90c1.2-.68,1.92-2.14,1.93-4.22V338a13.23,13.23,0,0,0-1.92-6.43Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M329.1,340.36c2.13,9.24,2.1,13.58,0,20.36l-5.43,3.14c2.09-6.78,2.12-11.12,0-20.36Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M211.61,407.89c2.13,9.24,2.1,13.45,0,20.23l-5.43,3.11c2.09-6.78,2.12-11,0-20.22Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.1,340.36c2.13,9.24,2.1,13.58,0,20.36l-5.43,3.14c2.09-6.78,2.12-11.12,0-20.36Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.61,407.89c2.13,9.24,2.1,13.45,0,20.23l-5.43,3.11c2.09-6.78,2.12-11,0-20.22Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Book-4",
    "data-name": "Book"
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "53.16 314 161.25 375.41 318.04 285.42 209.95 224 53.16 314",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "53.16 314 161.25 375.41 318.04 285.42 209.95 224 53.16 314",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.55,416,68,355.73c1.79-5.06,1.65-6.6-.37-13.34l105.15,59.82S174,402.12,173.55,416Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M169.25,396.68a14.4,14.4,0,0,1,6.57,11.3v8.83c0,4.17-2.94,5.85-6.57,3.77L64.66,360.91v-3.27l103.7,58.91c2.17,1.25,3.93.24,3.93-2.26l-.06-7.86a8.67,8.67,0,0,0-3.94-6.79L64.66,340.71V337Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.25,396.68a14.4,14.4,0,0,1,6.57,11.3v8.83c0,4.17-2.94,5.85-6.57,3.77L64.66,360.91v-3.27l103.7,58.91c2.17,1.25,3.93.24,3.93-2.26l-.06-7.86a8.67,8.67,0,0,0-3.94-6.79L64.66,340.71V337Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.65,337l156.79-90L326,306.68A14.42,14.42,0,0,1,332.6,318v8.83c0,2.08-.73,3.54-1.93,4.22L173.89,421c1.19-.69,1.92-2.15,1.92-4.22V408a14.43,14.43,0,0,0-6.56-11.31Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.65,337l156.79-90L326,306.68A14.42,14.42,0,0,1,332.6,318v8.83c0,2.08-.73,3.54-1.93,4.22L173.89,421c1.19-.69,1.92-2.15,1.92-4.22V408a14.43,14.43,0,0,0-6.56-11.31Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.85,
    style: {
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M173.9,401.55a13.23,13.23,0,0,1,1.92,6.43v8.84c0,2.07-.73,3.53-1.92,4.22l156.78-90c1.2-.68,1.93-2.14,1.93-4.22V318a13.25,13.25,0,0,0-1.93-6.43Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.9,401.55a13.23,13.23,0,0,1,1.92,6.43v8.84c0,2.07-.73,3.53-1.92,4.22l156.78-90c1.2-.68,1.93-2.14,1.93-4.22V318a13.25,13.25,0,0,0-1.93-6.43Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M315.25,320.32c2.13,9.24,2.1,12.85,0,19.63l-5.44,3.14c2.1-6.78,2.13-10.39,0-19.64Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M197.76,387.82c2.13,9.24,2.1,12.74,0,19.52l-5.44,3.13c2.1-6.77,2.13-10.27,0-19.51Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Graduation_Cap",
    "data-name": "Graduation Cap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graduation_Cap-2",
    "data-name": "Graduation Cap"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M307.85,195.93v40.7c0,5.86,5.15,11.72,15.37,16.19,20.48,9,53.69,9,74.17,0,10.25-4.49,15.36-10.36,15.36-16.24V195.93h0c.12-6-5-11.91-15.35-16.44-20.48-9-53.69-9-74.17,0C312.85,184,307.74,190,307.86,195.93Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#37474f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M307.86,195.93c-.12-6,5-11.91,15.36-16.44,20.48-9,53.69-9,74.17,0,10.36,4.54,15.47,10.49,15.35,16.44h0v18.59c0-4.61-4.09-7.91-16.2-3.45-19.85,7.31-31,19.38-51.24,25.35-16.74,4.93-31.57,3-37.46-3.13V195.93Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M307.85,217.47v4.62c0,5.85,5.15,11.72,15.37,16.18,20.48,9,53.69,9,74.17,0,10.32-4.51,15.43-10.45,15.36-16.37v-4.48c0,5.88-5.11,11.75-15.36,16.24-20.48,9-53.69,9-74.17,0C313,229.19,307.88,223.34,307.85,217.47Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.23 139.32 348.81 100.39 266.4 139.32 266.4 145.81 348.81 180.41 431.23 145.81 431.23 139.32",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "348.81 180.41 348.81 173.92 431.23 139.32 431.23 145.81 348.81 180.41",
    fill: "#ba68c8",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.81 173.92 430.04 141.24 431.23 145.81 431.23 139.32 348.81 173.92",
    fill: "#ba68c8",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.81 100.39 266.4 139.32 348.81 173.92 431.23 139.32 348.81 100.39",
    fill: "#455a64"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M316.11,214.83c0-.54-.26-13.19,1-16.79s5.94-7.25,15.71-12.21a103.13,103.13,0,0,1,21.95-8.1l.4,1.8a100.5,100.5,0,0,0-21.51,7.94c-9.19,4.66-13.75,8.11-14.8,11.17-.94,2.73-.95,12.58-.87,16.15Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.11,214.83c0-.54-.26-13.19,1-16.79s5.94-7.25,15.71-12.21a103.13,103.13,0,0,1,21.95-8.1l.4,1.8a100.5,100.5,0,0,0-21.51,7.94c-9.19,4.66-13.75,8.11-14.8,11.17-.94,2.73-.95,12.58-.87,16.15Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M326.82,253.52c0-9.48-1.57-26.43-6.54-31.36h-6.55c-5,4.93-6.53,21.89-6.53,31.36h0c0,1.45.95,2.9,2.87,4a15.32,15.32,0,0,0,13.87,0c1.92-1.11,2.88-2.56,2.88-4Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.82,253.52c0-9.48-1.57-26.43-6.54-31.36h-6.55c-5,4.93-6.53,21.89-6.53,31.36h0c0,1.45.95,2.9,2.87,4a15.32,15.32,0,0,0,13.87,0c1.92-1.11,2.88-2.56,2.88-4Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.73,222.16a9.59,9.59,0,0,0-1.06,1.31c1.25,1.33,3.17,1.67,5.08,1.82s3.9,1.7,4.75,9.47,2.5,17.69-.58,20.7-9.95,3-13.56.74h0a7.3,7.3,0,0,0,1.71,1.33,15.32,15.32,0,0,0,13.87,0c1.92-1.11,2.88-2.56,2.88-4h0c0-9.47-1.57-26.43-6.54-31.36Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M321.92,218.71a4.92,4.92,0,1,1-4.91-4.92A4.91,4.91,0,0,1,321.92,218.71Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.92,218.71a4.92,4.92,0,1,1-4.91-4.92A4.91,4.91,0,0,1,321.92,218.71Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.86,214.72a4.46,4.46,0,0,1-1.19,6.39,4.79,4.79,0,0,1-6.33-.94,4.9,4.9,0,1,0,7.52-5.45Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M353.67,175.38a3.3,3.3,0,0,1,1.94-2.7,10.38,10.38,0,0,1,9.37,0,3.31,3.31,0,0,1,1.94,2.7v2.17a3.3,3.3,0,0,1-1.94,2.7,10.38,10.38,0,0,1-9.37,0,3.3,3.3,0,0,1-1.94-2.7Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M365,178.09c2.59-1.5,2.59-3.92,0-5.41a10.36,10.36,0,0,0-9.36,0c-2.59,1.49-2.59,3.91,0,5.41A10.36,10.36,0,0,0,365,178.09Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#37474f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Apple"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apple-2",
    "data-name": "Apple"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M97.94,373.09c5.86-.65,16.07-1.6,24.55,10.26,9.66,13.49,5.63,33-4,42.63-12.14,12-33.66,16.31-48.38,6.88C53.81,422.43,48.63,398.29,56.43,386s23.1-11.77,27.24-10.79C89.87,376.68,93.39,373.6,97.94,373.09Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.55,428.52c16.41,5.65,36.47-.41,47.27-12a31.13,31.13,0,0,1-6.37,9.49c-12.14,12-33.66,16.31-48.38,6.88C57.74,425,51.8,409.17,53,396.64,53,400.1,59.49,422.3,77.55,428.52Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.84,377.22c3.68-1,9.67,1.43,13.38,6,4.61,5.72,6.57,14.58,6.58,21.26,0,13.47-11.48,22.5-12.89,21.59s6.32-11-1-23.2C103.56,390.57,98.8,378.79,104.84,377.22Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.09,378.84c4,.64,9.47,6,11.35,10.09s1.82,7.14,1.32,7.74c-.9,1.09-9.92-5.15-13-8.11C103.37,384.35,101.6,377.81,108.09,378.84Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M93.83,385.32c1.75-2,3.52-3.11,5-.84s-3.34,7-9.63,6.29-9-4.29-9.25-6.29c0,0,3.44,3.83,7.54,3.63A10.25,10.25,0,0,0,93.83,385.32Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9,389.23a56.94,56.94,0,0,1-.09-16.85c1.41-8.15,5.29-14.34,6.49-15.16a16.34,16.34,0,0,1,6.39-2.1c3.09-.49,7.11,1,6.3,2.31s-5.09,3-9.61,8.94-8,16.6-7,22.44A2.39,2.39,0,0,1,88.9,389.23Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#37474f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M95.51,357.09l.28-.17,0,0a18,18,0,0,1,5.88-1.78c2.27-.36,5,.34,6,1.27.29.41-.29,1.12-3,2a17.4,17.4,0,0,1-8.22.62C95.27,358.75,94.63,357.77,95.51,357.09Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.25,378.86c1.24-7.34,7.61-14.37,12.2-17.78h0a31.52,31.52,0,0,0-5.07,5.3c-4.53,5.94-8,16.59-7,22.43a2.4,2.4,0,0,1-2.47.42s-.35-2.1-.56-5.19C89,386.84,90.1,385.63,91.25,378.86Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3,376.91a14.69,14.69,0,0,1-14.31-3c-5.18-4.85-3.66-12.57-3.66-12.57a13.68,13.68,0,0,1,12.45,1.69C87.19,366.21,89,373.47,88.3,376.91Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,376.91a14.69,14.69,0,0,1-14.31-3c-5.18-4.85-3.66-12.57-3.66-12.57a13.68,13.68,0,0,1,12.45,1.69C87.19,366.21,89,373.47,88.3,376.91Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M70.33,361.37a13.68,13.68,0,0,1,12.45,1.69c4.41,3.15,6.18,10.41,5.51,13.85C83,366.77,70.33,361.37,70.33,361.37Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.33,361.37a13.68,13.68,0,0,1,12.45,1.69c4.41,3.15,6.18,10.41,5.51,13.85C83,366.77,70.33,361.37,70.33,361.37Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Pen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pen-2",
    "data-name": "Pen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pen-3",
    "data-name": "Pen"
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M369.1,364.59a10.25,10.25,0,0,0,4.64,8,3.69,3.69,0,0,0,2.66.56,2.15,2.15,0,0,1-.5.4l1.11-.64.07,0,.16-.11a1.81,1.81,0,0,0,.21-.18l.12-.12,0,0,.11-.13a2.85,2.85,0,0,0,.38-.69,2.09,2.09,0,0,0,.08-.23.23.23,0,0,0,0-.11.84.84,0,0,0,.05-.2,4.63,4.63,0,0,0,.13-1.16,10.25,10.25,0,0,0-4.63-8,4.14,4.14,0,0,0-2.08-.64h0l-.28,0-.27.05-.16,0-.1,0-.19.08,0,0-.17.09-1,.55a1.64,1.64,0,0,1,.5-.17A3.66,3.66,0,0,0,369.1,364.59Zm7.64,8.49.08,0Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23,431.6,255.76,443l1.11-.64,119-68.75a2.38,2.38,0,0,0,.5-.4,3.67,3.67,0,0,0,.86-2.6,10.25,10.25,0,0,0-4.64-8,4.19,4.19,0,0,0-2.07-.63,2.81,2.81,0,0,0-.59.06,2,2,0,0,0-.5.18l-.08,0,0,0h0Z",
    transform: "translate(-11.49 -43.64)",
    fill: "none",
    stroke: "#f0f0f0",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5,431.93c-2.56-1.48-4.63-.28-4.63,2.67a10.24,10.24,0,0,0,4.63,8c2.56,1.48,4.64.28,4.64-2.68A10.23,10.23,0,0,0,252.5,431.93Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M318.3,396.61s0,0,0,0l.15-.09a1.23,1.23,0,0,1,1.08.16,3.66,3.66,0,0,1,1.65,2.85,1.23,1.23,0,0,1-.39,1h0l-.2.12-70.44,40.66-4.63-2.68Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#455a64"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M256.72,437.51l-6.54,3.78-4.63-2.68,8.86-5.11A11.19,11.19,0,0,1,256.72,437.51Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#37474f"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M240.21,441.9h0l5.37-5.9.14-.16a2.1,2.1,0,0,1,2.65,0,7.24,7.24,0,0,1,3.27,5.67,2.17,2.17,0,0,1-1.24,2.26h-.06l-.21.05-7.87,1.71h0a1.23,1.23,0,0,1-.85-.18,3.31,3.31,0,0,1-1.49-2.58A1.15,1.15,0,0,1,240.21,441.9Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.21,441.9h0l5.37-5.9.14-.16a2.1,2.1,0,0,1,2.65,0,7.24,7.24,0,0,1,3.27,5.67,2.17,2.17,0,0,1-1.24,2.26h-.06l-.21.05-7.87,1.71h0a1.23,1.23,0,0,1-.85-.18,3.31,3.31,0,0,1-1.49-2.58A1.15,1.15,0,0,1,240.21,441.9Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M239.91,442.76a3.31,3.31,0,0,0,1.49,2.58,1.23,1.23,0,0,0,.85.18h0l4-.87c.62-.13,1-.72,1-1.66a5.28,5.28,0,0,0-2.38-4.14,1.54,1.54,0,0,0-1.91,0l-.11.12-2.66,2.92h0A1.15,1.15,0,0,0,239.91,442.76Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.4,441.89c-.82-.47-1.49-.09-1.49.87a3.31,3.31,0,0,0,1.49,2.58c.83.47,1.49.09,1.49-.86A3.3,3.3,0,0,0,241.4,441.89Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M359.45,372.82a1.13,1.13,0,0,1,1.16.11,3.61,3.61,0,0,1,1.64,2.84,1.15,1.15,0,0,1-.48,1.07h0l-40.94,23.67a1.22,1.22,0,0,0,.38-1,3.69,3.69,0,0,0-1.65-2.86,1.25,1.25,0,0,0-1.08-.15Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fafafa"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M359,373.88a3.62,3.62,0,0,0,1.64,2.84,1,1,0,0,0,1.64-1,3.61,3.61,0,0,0-1.64-2.84,1,1,0,0,0-1.64.95Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f5f5f5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M362.64,366.86h0l.05,0,.07,0,6.84-4,.16-.09,0,0h0a3,3,0,0,1,2.82.35,9.22,9.22,0,0,1,4.18,7.23,2.92,2.92,0,0,1-1.24,2.7h0l-6.92,4,0,0,0,0h0a3,3,0,0,1-2.89-.32,9.24,9.24,0,0,1-4.17-7.23A3,3,0,0,1,362.64,366.86Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.64,366.86h0l.05,0,.07,0,6.84-4,.16-.09,0,0h0a3,3,0,0,1,2.82.35,9.22,9.22,0,0,1,4.18,7.23,2.92,2.92,0,0,1-1.24,2.7h0l-6.92,4,0,0,0,0h0a3,3,0,0,1-2.89-.32,9.24,9.24,0,0,1-4.17-7.23A3,3,0,0,1,362.64,366.86Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.67,367.1c-2.3-1.33-4.17-.26-4.17,2.4a9.24,9.24,0,0,0,4.17,7.23c2.31,1.33,4.17.25,4.17-2.41A9.19,9.19,0,0,0,365.67,367.1Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M238,444.39h0l2.83-1.7h0a.53.53,0,0,1,.55,0,1.72,1.72,0,0,1,.77,1.33.53.53,0,0,1-.23.49h0l-2.82,1.71h0a1.11,1.11,0,0,1-.52.13,1.08,1.08,0,0,1-1.09-1.08A1.07,1.07,0,0,1,238,444.39Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#455a64"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M237.85,444.52h0l.15-.12h0a.54.54,0,0,1,.49.08,1.7,1.7,0,0,1,.77,1.32.53.53,0,0,1-.22.49l-.06,0-.05,0a.83.83,0,0,1-.35.06,1.09,1.09,0,0,1-1.09-1.09A1,1,0,0,1,237.85,444.52Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Pencil"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pencil-2",
    "data-name": "Pencil"
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M419.59,367.56,438,364a.57.57,0,0,1,.54.94L426,379Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ffa8a7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M438.51,364.89A.57.57,0,0,0,438,364l-3.59.71h0a3.12,3.12,0,0,1,1.48,2.93l0,.32Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M335.69,430.75l1.5-.86,1.82-1L426,379a8.39,8.39,0,0,0-.51-6.1c-1.3-2.92-3.83-5.22-5.93-5.36l-87,49.82-3.47,2C331.45,418.21,338,429.55,335.69,430.75Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#455a64"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M341.42,427.48l3.36-1.93c1-.53.42-3-.74-5.48-1.53-3.34-4.55-6.58-5.86-5.89l-2.48,1.42-.88.53c1.32-.7,4.34,2.54,5.87,5.89,1.11,2.41,1.67,4.76.83,5.4h0A.15.15,0,0,1,341.42,427.48Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ebebeb"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M342.26,427c2.3-1.22-4.3-12.58-6.6-11.36l-3.37,1.93c2.31-1.22,8.9,10.14,6.6,11.36Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M335.69,430.75l3.32-1.9c2.27-1.18-4-12.2-6.4-11.47l-.14.05-3.33,1.94C331.45,418.21,338,429.55,335.69,430.75Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.59,364.27,438,364l-13.34,7.29-90.77,52c-.13-.2-.24-.22-.32-.08,2,3.06,3.44,6.91,2.15,7.58l1.5-.86,1.82-1L426,379h0l12.47-14.12A.57.57,0,0,0,438.59,364.27Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M321.6,438.81l14.09-8.06c1-.51.44-2.92-.7-5.43-1.52-3.35-4.53-6.62-5.85-5.95h0L315,427.47c-2.8,1.62-.22,7.71,2.91,10.44C319.06,438.94,320.36,439.39,321.6,438.81Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f28f8f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,434.44c-.81-3.17-3.38-6.29-5.75-6.95a2.27,2.27,0,0,0-2.11.28c-2.12,2,.35,7.56,3.31,10.14a3.37,3.37,0,0,0,3.63.93C322.58,438.22,323,436.6,322.44,434.44Z",
    transform: "translate(-11.49 -43.64)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-2",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-3",
    "data-name": "Speech Bubble"
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Speech_Bubble-4",
    "data-name": "Speech Bubble",
    d: "M262.64,94.69l15.15-7.92s9.61,2.46,25.67,1.51c23.74-1.41,37.61-11.44,34.08-25.52-3.62-14.43-19.5-20.09-47.81-19-35.41,1.38-44,25.39-22.86,39.58Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Speech_Bubble-5",
    "data-name": "Speech Bubble",
    d: "M262.64,94.69l15.15-7.92s9.61,2.46,25.67,1.51c23.74-1.41,37.61-11.44,34.08-25.52-3.62-14.43-19.5-20.09-47.81-19-35.41,1.38-44,25.39-22.86,39.58Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 267.4,
    cy: 22.9,
    r: 3.77,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.15,
    cy: 22.9,
    r: 3.77,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.91,
    cy: 22.9,
    r: 3.77,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laptop"
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M72.27,323.28c0,2.58,1.94,4.24,4.33,5.62l97.85,56.5a9.62,9.62,0,0,0,8.65,0L341,294.26c2.38-1.38,4.32-3.15,4.32-5.74s-1.94-4.19-4.32-5.57L243.1,226.46a9.53,9.53,0,0,0-8.64,0L76.6,317.6C74.21,319,72.27,320.69,72.27,323.28Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#37474f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6,322.59l97.85,56.49a9.55,9.55,0,0,0,8.65,0L341,288c2.38-1.38,2.38-3.62,0-5L243.1,226.46a9.53,9.53,0,0,0-8.64,0L76.6,317.6C74.21,319,74.21,321.21,76.6,322.59Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#455a64"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M178.78,380.13v6.3a8.83,8.83,0,0,1-4.33-1L76.6,328.9c-2.39-1.38-4.33-3-4.33-5.62,0-2.43,1.74-4.12,4-5.49-1.85,1.31-1.89,3.51.34,4.8l97.85,56.5A8.83,8.83,0,0,0,178.78,380.13Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M70.39,318.27c-1.89-.88-2.41-2.38-2.59-5l-8.48-124.1a8.6,8.6,0,0,1,4-7.3L221.18,90.69c2.38-1.38,4.13-2.13,6.34-.62s2.25,2.34,2.43,5l8.48,124.11a8.61,8.61,0,0,1-4,7.3L76.58,317.61C74.19,319,72.84,319.39,70.39,318.27Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#37474f"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M230,95.06c-.18-2.65-2.26-3.68-4.65-2.31L67.44,183.9a8.25,8.25,0,0,0-3,3.17L60.36,185h0a8.35,8.35,0,0,1,3-3.17L221.17,90.69c2.39-1.38,4.15-2.14,6.34-.62S229.77,92.41,230,95.06Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#455a64"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M76.26,317.79c-2.18,1.28-3.55,1.44-5.86.47-1.77-.74-2.41-2.37-2.59-5L59.32,189.13a7.67,7.67,0,0,1,1-4.12l4.12,2.05h0a7.8,7.8,0,0,0-1,4.12L71.93,315.3C72.09,317.76,74.22,319,76.26,317.79Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M70.18,188.64,222.1,101c1.43-.83,2.68-.21,2.79,1.38l7.91,115.78a5.16,5.16,0,0,1-2.39,4.38L78.49,310.18c-1.43.83-2.68.21-2.79-1.38L67.78,193A5.19,5.19,0,0,1,70.18,188.64Z",
    transform: "translate(-11.49 -43.64)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M70.18,188.64a5.19,5.19,0,0,0-2.4,4.38l7.79,113.85,150.18-86.68a5.16,5.16,0,0,0,2.39-4.38L220.36,102Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.18,188.64a5.19,5.19,0,0,0-2.4,4.38l7.79,113.85,150.18-86.68a5.16,5.16,0,0,0,2.39-4.38L220.36,102Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M90,318.33,235,234.58a4.51,4.51,0,0,1,4.08,0l5.29,3a1.25,1.25,0,0,1,0,2.36L99.29,323.64a4.51,4.51,0,0,1-4.08,0l-5.26-3A1.24,1.24,0,0,1,90,318.33Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M104.19,326.73,249.26,243a4.16,4.16,0,0,1,3.73-.2l37.75,21.8c.93.54.78,1.5-.35,2.15l-144.9,83.64a4.17,4.17,0,0,1-3.72.21l-37.92-21.7C102.91,328.34,103.07,327.38,104.19,326.73Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M229.9,278.16l4.54-2.62c.19-.12.21-.29,0-.39l-4.35-2.5a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38l4.34,2.51A.75.75,0,0,0,229.9,278.16Zm-6.64-9.08-4.54,2.63c-.19.11-.21.28,0,.38L223,274.6a.73.73,0,0,0,.66,0l4.54-2.63c.19-.11.21-.28,0-.38l-4.35-2.51A.73.73,0,0,0,223.26,269.08Zm-14.67,8.48L200.9,282c-.19.12-.21.29,0,.39l4.35,2.5a.73.73,0,0,0,.66,0l7.69-4.44c.19-.11.21-.28,0-.38l-4.35-2.51A.74.74,0,0,0,208.59,277.56Zm8-4.64-4.55,2.62c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.19-.12.21-.29,0-.39l-4.35-2.5A.71.71,0,0,0,216.63,272.92ZM198.81,283.2l-4.54,2.63c-.2.11-.21.28,0,.38l4.34,2.51a.73.73,0,0,0,.66,0l4.54-2.63c.2-.11.21-.28,0-.38l-4.34-2.51A.73.73,0,0,0,198.81,283.2ZM192.17,287l-4.54,2.62c-.2.11-.21.28,0,.38l4.34,2.51a.73.73,0,0,0,.66,0l4.55-2.63c.19-.11.21-.28,0-.38l-4.34-2.5A.73.73,0,0,0,192.17,287Zm17,10.23,4.54-2.62c.2-.11.21-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.54,2.62c-.2.12-.22.29,0,.39l4.34,2.51A.71.71,0,0,0,209.2,297.27Zm-6.64,3.84,4.54-2.63c.2-.11.21-.28,0-.38l-4.34-2.5a.73.73,0,0,0-.66,0l-4.54,2.62c-.2.11-.21.28,0,.38l4.34,2.51A.73.73,0,0,0,202.56,301.11Zm-6.64,3.83,4.55-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0L191,302.07c-.19.12-.21.29,0,.38l4.34,2.51A.73.73,0,0,0,195.92,304.94Zm-6.63,3.83,4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.29,0,.39l4.35,2.5A.73.73,0,0,0,189.29,308.77Zm34-26.78,4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.12-.21.29,0,.39l4.35,2.5A.73.73,0,0,0,223.26,282Zm-7.42,11.45L226,287.59c.19-.11.21-.28,0-.38l-10.55-6.09a.73.73,0,0,0-.66,0l-5.24,3c-.2.11-.21.28,0,.38l5.58,3.22c.17.1.16.27,0,.38l-4.19,2.43c-.19.11-.21.28,0,.38l4.35,2.51A.77.77,0,0,0,215.84,293.44Zm-30.31-2.57L181,293.49c-.19.11-.21.28,0,.38l4.34,2.51a.73.73,0,0,0,.66,0l4.55-2.62c.19-.11.21-.28,0-.38l-4.35-2.51A.73.73,0,0,0,185.53,290.87Zm-6.64,3.83-4.54,2.63c-.19.11-.21.28,0,.38l4.35,2.51a.77.77,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51A.73.73,0,0,0,178.89,294.7Zm-36.73,40.92a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.29,0,.38Zm-16.37-10.26L121.24,328c-.19.11-.21.28,0,.38l4.35,2.51a.77.77,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.34-2.51A.73.73,0,0,0,125.79,325.36Zm8.41,7.69a.73.73,0,0,0,.66,0l4.54-2.63c.2-.11.21-.28,0-.38l-4.34-2.51a.71.71,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38Zm18.32,4.12,4.54-2.62c.19-.12.21-.29,0-.39l-4.35-2.5a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38l4.35,2.51A.73.73,0,0,0,152.52,337.17Zm-7.3,3.85a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.29,0,.38Zm-12.8-19.49-4.54,2.62c-.19.12-.21.29,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51A.73.73,0,0,0,132.42,321.53Zm33.2-19.16L161.07,305c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.19-.12.21-.29,0-.39l-4.35-2.5A.71.71,0,0,0,165.62,302.37ZM139.06,317.7l-4.54,2.62c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51A.73.73,0,0,0,139.06,317.7Zm33.19-19.16-4.54,2.62c-.19.11-.21.28,0,.38l4.35,2.51a.71.71,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51A.71.71,0,0,0,172.25,298.54ZM159,306.2l-4.55,2.62c-.19.11-.21.29,0,.38l4.34,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.2-.11.21-.28,0-.38l-4.34-2.51A.73.73,0,0,0,159,306.2ZM152.34,310l-4.54,2.63c-.2.11-.22.28,0,.38l4.34,2.51a.77.77,0,0,0,.66,0l4.54-2.62c.2-.11.21-.28,0-.38L153,310A.73.73,0,0,0,152.34,310Zm-6.64,3.84-4.54,2.62c-.2.11-.21.28,0,.38l4.34,2.51a.73.73,0,0,0,.66,0l4.55-2.63c.19-.11.21-.28,0-.38l-4.34-2.51A.74.74,0,0,0,145.7,313.87ZM176,316.44l4.54-2.62c.19-.12.21-.29,0-.39l-4.35-2.51a.77.77,0,0,0-.66,0L171,313.57c-.19.11-.21.28,0,.38l4.35,2.51A.73.73,0,0,0,176,316.44Zm61.93-55.83-4.54,2.62c-.2.12-.21.29,0,.39l4.34,2.5a.73.73,0,0,0,.66,0l4.54-2.62c.2-.11.21-.28,0-.38l-4.34-2.51A.73.73,0,0,0,237.94,260.61Zm-8,4.64-4.54,2.62c-.19.12-.21.29,0,.39l4.35,2.5a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51A.73.73,0,0,0,229.9,265.25Zm14.68-8.47L240,259.4c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.19-.12.21-.29,0-.39l-4.34-2.5A.73.73,0,0,0,244.58,256.78Zm-36.7,34.09,4.55-2.63c.19-.11.21-.28,0-.38l-4.34-2.51a.71.71,0,0,0-.66,0L202.92,288c-.19.11-.21.28,0,.38l4.34,2.51A.73.73,0,0,0,207.88,290.87Zm44-38a.71.71,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.63c.19-.11.21-.28,0-.38Zm-69.22,59.69,4.54-2.63c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.19.11-.21.28,0,.38l4.35,2.51A.73.73,0,0,0,182.65,312.61Zm81.4-47L268.6,263c.19-.11.21-.28,0-.38l-4.34-2.51a.71.71,0,0,0-.66,0l-4.54,2.62c-.2.11-.21.28,0,.38l4.34,2.51A.7.7,0,0,0,264.05,265.6Zm-12.84.25,4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.71.71,0,0,0-.65,0L246.24,263c-.19.11-.21.28,0,.38l4.35,2.51A.74.74,0,0,0,251.21,265.85Zm6.87-9.34a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38Zm1.4-.81L270,261.79a.73.73,0,0,0,.66,0l4.55-2.62c.19-.11.21-.28,0-.38l-10.55-6.09a.73.73,0,0,0-.66,0l-4.54,2.62C259.33,255.43,259.31,255.6,259.48,255.7Zm-15.33,8.5-4.55,2.62c-.19.11-.21.28,0,.38l4.34,2.51a.71.71,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.34-2.51A.73.73,0,0,0,244.15,264.2Zm-50,28.84-4.54,2.62c-.19.12-.21.29,0,.39l4.35,2.5a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38L194.84,293A.73.73,0,0,0,194.18,293Zm62.58-23.58a.73.73,0,0,0,.66,0l4.54-2.62c.19-.12.21-.29,0-.39l-4.35-2.5a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38Zm-55.94,19.75-4.54,2.62c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.29,0-.38l-4.35-2.51A.73.73,0,0,0,200.82,289.21Zm-52,42.58a.75.75,0,0,0,.67,0l4.54-2.62c.19-.12.21-.29,0-.39l-4.35-2.5a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38Zm-7.71-8.09-4.54,2.63c-.2.11-.22.28,0,.38l4.34,2.51a.74.74,0,0,0,.66,0l4.54-2.62c.2-.11.21-.28,0-.38l-4.34-2.51A.73.73,0,0,0,141.08,323.7Zm15,4.23,4.55-2.62c.19-.11.21-.28,0-.38l-4.34-2.51a.71.71,0,0,0-.66,0l-4.54,2.62c-.2.11-.21.28,0,.38l4.34,2.51A.71.71,0,0,0,156.09,327.93Zm6.64-3.83,4.54-2.62c.2-.11.21-.28,0-.38L163,318.59a.73.73,0,0,0-.66,0l-4.54,2.63c-.2.11-.21.28,0,.38l4.34,2.51A.77.77,0,0,0,162.73,324.1Zm6.64-3.83,4.54-2.62c.19-.11.21-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38l4.35,2.51A.73.73,0,0,0,169.37,320.27Zm-21.66-.4-4.54,2.62c-.19.11-.21.29,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.2-.11.21-.28,0-.38l-4.34-2.51A.75.75,0,0,0,147.71,319.87Zm6.64-3.83-4.54,2.62c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.63c.19-.11.21-.28,0-.38L155,316A.77.77,0,0,0,154.35,316Zm26.56-15.33-4.55,2.62c-.19.11-.21.28,0,.38l4.34,2.51a.73.73,0,0,0,.66,0l4.54-2.63c.2-.11.21-.28,0-.38l-4.34-2.51A.77.77,0,0,0,180.91,300.71Zm-6.64,3.83-4.54,2.62c-.2.11-.21.28,0,.38l4.34,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.2-.11.22-.28,0-.38l-4.34-2.51A.73.73,0,0,0,174.27,304.54Zm13.27-7.66L183,299.5c-.19.11-.21.28,0,.38l4.35,2.51a.71.71,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51A.71.71,0,0,0,187.54,296.88ZM161,312.2l-4.54,2.63c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.63c.19-.11.21-.28,0-.38l-4.35-2.51A.73.73,0,0,0,161,312.2Zm6.64-3.83L163.09,311c-.19.12-.21.29,0,.39l4.34,2.51a.77.77,0,0,0,.66,0l4.55-2.62c.19-.11.21-.28,0-.38l-4.35-2.51A.73.73,0,0,0,167.63,308.37Zm-8.47,25,4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.19.11-.21.28,0,.38l4.34,2.51A.73.73,0,0,0,159.16,333.33Zm-35-1.65-4.34-2.51a.77.77,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.63C124.31,332,124.32,331.78,124.15,331.68Zm8.65,2.18-4.34-2.51a.73.73,0,0,0-.66,0l-7,4c-.19.11-.21.29,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l7-4C133,334.12,133,334,132.8,333.86Zm-15.13-7.13-4.35-2.51a.73.73,0,0,0-.66,0l-5.59,3.23c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l5.59-3.23C117.82,327,117.84,326.83,117.67,326.73Zm4.28-2.48a.73.73,0,0,0,.66,0l4.54-2.62c.2-.11.21-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.55,2.62c-.19.12-.21.29,0,.38Zm18.81,12.18-4.35-2.51a.73.73,0,0,0-.66,0L127,339c-.19.11-.21.28,0,.38l4.34,2.51a.75.75,0,0,0,.67,0l8.73-5.05C140.91,336.7,140.93,336.53,140.76,336.43Zm3.06,5.4-4.34-2.51a.73.73,0,0,0-.66,0l-5.59,3.23c-.19.11-.21.28,0,.38l4.34,2.51a.73.73,0,0,0,.66,0l5.59-3.23C144,342.1,144,341.93,143.82,341.83Zm27.49-46.07a.73.73,0,0,0,.66,0l4.54-2.63c.19-.11.21-.28,0-.38l-4.35-2.51a.71.71,0,0,0-.66,0L167,292.87c-.19.11-.21.28,0,.38ZM158,303.42a.73.73,0,0,0,.66,0l4.54-2.62c.2-.11.21-.29,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38Zm-29.44,17a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.29,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38Zm36.08-20.83a.73.73,0,0,0,.66,0l4.54-2.62c.2-.12.21-.29,0-.39l-4.34-2.5a.73.73,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38Zm-13.28,7.67a.73.73,0,0,0,.66,0l4.55-2.62c.19-.11.21-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.2.11-.21.28,0,.38Zm-4.31,34.84a.73.73,0,0,0-.66,0l-7,4c-.19.11-.21.29,0,.39l4.34,2.5a.73.73,0,0,0,.66,0l7-4c.19-.11.21-.29,0-.39Zm-5.21-29.34a.71.71,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.19.11-.21.28,0,.38Zm-6.64,3.83a.73.73,0,0,0,.66,0l4.54-2.63c.19-.11.21-.28,0-.38l-4.35-2.51a.71.71,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38Zm134.84-45.5a.73.73,0,0,0-.66,0l-11.18,6.46c-.2.11-.21.28,0,.38l4.34,2.51a.73.73,0,0,0,.66,0L274.37,274c.2-.11.21-.28,0-.38Zm-14.68,8.48a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.19-.12.21-.29,0-.39Zm-89.6,49.93,4.55-2.62c.19-.11.21-.28,0-.38L166,324a.73.73,0,0,0-.66,0l-4.54,2.63c-.19.11-.21.28,0,.38l4.35,2.51A.75.75,0,0,0,165.79,329.5Zm76.33-42.27a.73.73,0,0,0-.66,0l-4.55,2.63c-.19.11-.21.28,0,.38l4.34,2.51a.77.77,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38Zm34.58-20a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.12-.21.29,0,.39l4.35,2.51a.77.77,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38Zm11-1.32-10.55-6.1a.77.77,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38L282.45,269a.73.73,0,0,0,.66,0l4.54-2.62C287.84,266.21,287.86,266,287.69,265.94Zm-70.38,35.61a.71.71,0,0,0-.66,0l-5.59,3.22c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l5.59-3.23c.19-.11.21-.28,0-.38Zm16.77-9.68a.73.73,0,0,0-.66,0l-7,4c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l7-4c.19-.11.21-.28,0-.38Zm-32.14,18.56a.73.73,0,0,0-.66,0L163.89,332c-.19.11-.21.28,0,.38l4.35,2.51a.77.77,0,0,0,.66,0l37.38-21.58c.19-.11.21-.28,0-.38Zm-39.48,22.79a.73.73,0,0,0-.66,0l-5.59,3.23c-.2.11-.21.28,0,.38l4.34,2.51a.73.73,0,0,0,.66,0l5.59-3.23c.19-.11.21-.28,0-.38ZM209.62,306a.73.73,0,0,0-.66,0l-5.59,3.23c-.19.11-.21.28,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l5.59-3.23c.19-.11.21-.28,0-.38Zm-54.85,31.67a.73.73,0,0,0-.66,0l-5.59,3.23c-.19.11-.21.28,0,.38l4.34,2.51a.75.75,0,0,0,.67,0l5.58-3.23c.2-.11.22-.28,0-.38ZM225,297.11a.77.77,0,0,0-.66,0l-5.59,3.22c-.2.12-.21.29,0,.39l4.34,2.51a.77.77,0,0,0,.66,0L229.3,300c.19-.12.21-.29,0-.39Zm23.75-13.71a.73.73,0,0,0-.66,0L243.55,286c-.19.11-.21.29,0,.38l4.35,2.51a.73.73,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38ZM263.62,273l4.54-2.62c.2-.11.22-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.54,2.62c-.2.11-.21.29,0,.39L263,273A.73.73,0,0,0,263.62,273Zm-27.09,1.31,4.55-2.63c.19-.11.21-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.2.11-.21.28,0,.38l4.34,2.51A.73.73,0,0,0,236.53,274.33ZM218.9,298.84l13.28-7.66c.19-.11.21-.29,0-.39l-4.35-2.5a.73.73,0,0,0-.66,0L213.94,296c-.2.11-.22.29,0,.39l4.34,2.5A.73.73,0,0,0,218.9,298.84Zm37.43-22a.74.74,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0L252,274c-.19.11-.21.28,0,.38Zm-5.55-3.61,4.54-2.62c.19-.11.21-.29,0-.38L251,267.76a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38l4.35,2.51A.73.73,0,0,0,250.78,273.27Zm-38.52,29.4,4.54-2.62c.2-.11.21-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.2.11-.21.28,0,.38l4.34,2.51A.71.71,0,0,0,212.26,302.67Zm29.39-17.32a.73.73,0,0,0,.66,0l4.54-2.63c.2-.11.21-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.2.11-.22.28,0,.38Zm-62.58,36.49,4.54-2.63c.2-.11.21-.28,0-.38l-4.34-2.51a.77.77,0,0,0-.66,0L174.11,319c-.2.11-.21.28,0,.38l4.34,2.51A.73.73,0,0,0,179.07,321.84Zm6.64-3.84,4.54-2.62c.2-.11.21-.28,0-.38L186,312.49a.73.73,0,0,0-.66,0l-4.55,2.63c-.19.11-.21.28,0,.38l4.34,2.51A.71.71,0,0,0,185.71,318Zm-13.28,7.67,4.55-2.62c.19-.11.21-.29,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.54,2.62c-.2.11-.21.28,0,.38l4.34,2.51A.73.73,0,0,0,172.43,325.67ZM199,310.34l4.54-2.62c.19-.12.21-.29,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0L194,307.47c-.19.11-.21.28,0,.38l4.35,2.51A.73.73,0,0,0,199,310.34Zm-6.64,3.83,4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.12-.21.29,0,.38l4.35,2.51A.73.73,0,0,0,192.35,314.17Zm13.28-7.66,4.54-2.63c.19-.11.21-.28,0-.38L205.86,301a.71.71,0,0,0-.66,0l-4.54,2.62c-.2.11-.21.28,0,.38l4.34,2.51A.75.75,0,0,0,205.63,306.51Zm36.22-53.32a.73.73,0,0,0,.66,0l4.54-2.63c.2-.11.21-.28,0-.38l-1.15-.67a.77.77,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38Zm-33,20.89a.73.73,0,0,0,.66,0l4.54-2.63c.19-.11.21-.28,0-.38l-4.35-2.5a.73.73,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38Zm13.27-7.67a.73.73,0,0,0,.66,0l4.54-2.62c.2-.11.21-.28,0-.38L223,260.88a.73.73,0,0,0-.66,0l-4.55,2.62c-.19.12-.21.29,0,.39Zm-21.38,12.35a.73.73,0,0,0,.66,0l4.54-2.63c.19-.11.21-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38Zm14.74-8.51a.73.73,0,0,0,.66,0l4.55-2.63c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.19.11-.21.28,0,.38Zm-28,16.17a.73.73,0,0,0,.66,0l4.55-2.62c.19-.11.21-.28,0-.38l-4.34-2.51a.73.73,0,0,0-.66,0l-4.54,2.62c-.2.12-.21.29,0,.39Zm6.64-3.83a.73.73,0,0,0,.66,0l4.54-2.62c.2-.11.21-.29,0-.38L195,277.06a.73.73,0,0,0-.66,0l-4.55,2.62c-.19.11-.21.28,0,.38Zm34.46-21.74a.73.73,0,0,0,.66,0l4.55-2.62c.19-.11.21-.28,0-.38l-1.16-.67a.73.73,0,0,0-.66,0l-4.54,2.62c-.2.11-.21.29,0,.38Zm19.92-11.49a.71.71,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-1.16-.67a.71.71,0,0,0-.66,0l-4.54,2.62c-.19.11-.21.28,0,.38Zm9.13,5.27a.71.71,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.19.11-.21.28,0,.38Zm12.64,14.56,4.54-2.62c.2-.11.21-.29,0-.39l-4.34-2.5a.73.73,0,0,0-.66,0l-4.54,2.62c-.2.11-.21.28,0,.38l4.34,2.51A.73.73,0,0,0,270.26,269.19Zm-35-12.17a.73.73,0,0,0,.66,0l4.54-2.62c.2-.11.21-.28,0-.38l-1.15-.67a.73.73,0,0,0-.66,0L234.09,256c-.19.11-.21.29,0,.38Zm-54.37,33.24a.71.71,0,0,0,.66,0l4.54-2.62c.19-.11.21-.28,0-.38l-4.35-2.51a.73.73,0,0,0-.66,0l-4.54,2.63c-.19.11-.21.28,0,.38Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#455a64"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.36 284.4 189.35 284.97 215.58 300.11 262.23 273.18 263.2 272.62 235.98 256.91 188.36 284.4",
    fill: "#263238"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.63 273.52 235.98 258.72 189.95 285.31 215.58 300.11 261.63 273.52",
    fill: "#37474f"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Character-2",
    "data-name": "Character"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.75,56.8c-8.2-5.37-18.77-4.41-24.49-.08-8,6.08-10.82,12.77-12.26,26-2,18.64-4.1,24-6.31,28.24a15.74,15.74,0,0,1-9.24,7.86A10.91,10.91,0,0,0,98,119.3c-1.88,9-4.5,16.54-2.17,26.05,1.57,6.4,4.91,13.65,9.84,18.24,4.2,3.91,10.21,5.11,15.26,7.32-3.41-7.32-5.24-14.22-2.88-22.44,2.6-9.07,8.67-16.79,11.37-25.93,3.73-12.64,8-25.74,9.07-38.93C139.42,72.45,139.84,64.44,139.75,56.8Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66,58.47c-1.31-1.23-7.1-.44-10.6,3.74s-5.58,10.23-1.33,13.48C127.71,78.74,143.18,62.51,135.66,58.47Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.15,76.77c2.88-1.06,4.11-4.77,3.25-7.72s-3.27-5.19-5.84-6.88a30.17,30.17,0,0,0-19.86-4.62,39.14,39.14,0,0,0-19.95-1,20.73,20.73,0,0,0-16,18.67c-10.27,2.42-14.76,15-8.42,28.5,4.61,9.77,15,16.52,16.29,21.37l38.94-30.26c1.51,2.37,6.22,2.48,8.14,1.54s3.12-4.42,1.84-6.14a6.78,6.78,0,0,0,1.6-13.47Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75,56.56a21.15,21.15,0,0,0-10.84,6.91A20.21,20.21,0,0,0,126.6,69a20.66,20.66,0,0,0-1.38,6.26l0,.33-.32.08a13.29,13.29,0,0,0-6.37,3.56,15.41,15.41,0,0,0-3.7,6.33,24.2,24.2,0,0,0,.67,14.71,37.44,37.44,0,0,0,7.8,12.84c1.67,1.92,3.43,3.76,5.13,5.67.84,1,1.69,1.91,2.45,3a9.94,9.94,0,0,1,1.78,3.37,10.12,10.12,0,0,0-1.95-3.24c-.79-1-1.68-1.9-2.56-2.82-1.78-1.82-3.61-3.61-5.33-5.5a50.89,50.89,0,0,1-4.8-6,30.27,30.27,0,0,1-3.42-6.94A27.61,27.61,0,0,1,113,93a20.76,20.76,0,0,1,.83-7.75,16.22,16.22,0,0,1,4-6.71,14.17,14.17,0,0,1,6.85-3.75l-.35.41a20.56,20.56,0,0,1,5.17-12.11,21,21,0,0,1,5.12-4.19A19.32,19.32,0,0,1,140.75,56.56Z",
    transform: "translate(-11.49 -43.64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.45,140.8c2.14-1.81,2.53-2.28,5.41-4.59,2.14-1.72,3.85-3.1,4.4-4.1,1.08-2,.07-3.93-.83-3.61-1.81.64-3.95,2.17-8.12,5-4.59,3.15-7.83,6.26-8.08,5.76a51.07,51.07,0,0,1,4.9-5.8c5.61-6.07,6.72-7.17,7.75-9.12,2.18-4.06-.88-4.73-2.22-3.89-1.53,1-3.19,2.79-7.21,6.78-4.36,4.33-8.16,8.74-8.51,8.48s5.69-6.87,9.3-11.71c3.36-4.49,1.18-6.39.22-6.54s-2.19,1.15-3.81,2.89C273.72,123.54,265.2,134,263.42,136s-3.13,2.72-3.36-.51c-.22-3-.07-6.26-1.39-8.35-2.21-3.49-4.65-2.63-4.66-.3,0,3.3-.79,7-1.37,12.27-.31,2.75-.26,6-.32,7.94-.34,6.69-5.95,10.15-10.62,13.37s-17.39,10.47-17.39,10.47-23.72-24.42-30.64-30.41c-8.22-7.12-10.57-7.62-22.18-7.52l16.42,42.22s22.32,20.65,29.9,25.06,10.65,2,19.87-6.17c7.07-6.27,18.71-20.64,21.52-23.83s4-5.25,7.29-6.45c4.43-1.62,6.71-3.85,9.65-7.23,1.41-1.61,3.75-4.85,5.9-7a100.35,100.35,0,0,1,9.18-7.73c1.95-1.63,2.25-5-.48-3.92-5.15,2-10.32,6.36-10.49,6.07S282,142.05,283.45,140.8Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ffbda7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,141c2.37,3.49,2.9,11.74.59,16.65C267.22,153,266.72,144.6,261.86,141Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.31,170.93c-3.93,2.58-8.62,10-7.28,17.64-1.71-5.63-3.19-12.68,5.43-19.7Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,145.35l9.15-3.67s13.65-3.54,25-6c12-1.51,22.31-2.63,22.31-2.63l4.05-.08s9,7.92,15.59,15.23,12.38,13.42,12.75,22.64c.49,12.48-7.52,17-7.52,17l.5,15.88,10.4,29.46L102.62,291.29c3.06-35.85,11-41.76,15.48-66.61-.86-13-7.33-30.84-8.43-39.89C105.85,153.45,111,145.35,111,145.35Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#020002"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.26,129.72c.38-4.39,1-13.12,1-13.12-1.09,1.46-7,3.46-11-2.22-4.66-6.55-3.92-11.24-.67-14.38,3.7-3.58,10.18-2.66,12.88,3,1.69,4,5-.71,1.67-7-1.11-11.06,13-3.73,21.79-26.79,8.87-.5,14.22,2,18.53,9.38,2,3.34,4.33,8.15,3.85,22.08-.62,17.74-3.29,23.32-9.5,26.29-2.86,1.37-5.8,1.89-11.31,1.48l-.05,1.7a8.11,8.11,0,0,0,.06,1.18,2,2,0,0,0,1.88,1.89,45.49,45.49,0,0,0,6.09-.17S172,144.4,157,147.64a51.74,51.74,0,0,1-36.9-6,53.64,53.64,0,0,0,6.43-3.89C131.16,134.44,132,132.47,132.26,129.72Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ffbda7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.51,113.54a2.16,2.16,0,1,0,2.09-2.24A2.15,2.15,0,0,0,126.51,113.54Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.84,111.17l9.64,3a5,5,0,0,1-6.23,3.5A5.29,5.29,0,0,1,154.84,111.17Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.47,113.39a5.56,5.56,0,0,1,5.59,4.29,4.89,4.89,0,0,1-2.81,0,5.21,5.21,0,0,1-3.53-4.18A6.15,6.15,0,0,1,155.47,113.39Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.58,87.07l-6.07-1.45a3,3,0,0,1,3.65-2.36A3.28,3.28,0,0,1,176.58,87.07Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,86.76l5.91-2.23a3,3,0,0,0-4-1.9A3.32,3.32,0,0,0,147,86.76Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.62,94.93A2.69,2.69,0,0,0,173,97.75a2.51,2.51,0,0,0,2.77-2.32,2.67,2.67,0,0,0-2.42-2.81A2.51,2.51,0,0,0,170.62,94.93Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,95.07a2.67,2.67,0,0,0,2.41,2.82,2.5,2.5,0,0,0,2.77-2.32,2.66,2.66,0,0,0-2.41-2.81A2.51,2.51,0,0,0,149.47,95.07Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.46,128.45a48.14,48.14,0,0,1-16.53-4.64,15.53,15.53,0,0,1-6.44-7.14,12.29,12.29,0,0,0,4.44,9c5,4.2,18.54,5.62,18.54,5.62a6.15,6.15,0,0,1-.06-1.18Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.3,190c4.89-4.15,7.37-5.78,9.72-6.61s10.5-4.84,13.66-5.84c2-.64,3,2.55.58,4.94-1.89,1.84-6.94,4.42-9.14,5.81s-6.33,7.11-6.33,7.11Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,226.44c-16,9.08-30,20.39-45.51,22.72-15.12,2.26-15.59-10.26-15.32-19.59.34-11.78,6.94-48.72,10.37-61,3.64-13.07,6-17.89,20.17-23.2,11.7,7.66,9,33,6.51,42.66-2.65,10.09-6.94,28.94-6.94,28.94s18.44-5.81,22.87-8.15,11.85-12.3,14.78-15.49c4-4.34,6.13-3.93,8.3-3.74,7.13.62,8.72,1.11,10.27,2a3.19,3.19,0,0,1,1.55,2.66c1.89.12,4.69-.12,5.25,2.94a8.57,8.57,0,0,1,.27,2.46,2.06,2.06,0,0,1,1.26.62c1.67,1.71-.61,8.14-2.21,9.77-1.13,1.15-2.82,1.39-5.07,1.23-1.92-.14-1.16-2.13-1.16-2.13l-2.65.33c-5.48,4.44-5.75,11-13.23,13.26A34.05,34.05,0,0,0,141.24,226.44Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ffbda7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.29,194.2,159.8,193H168A3.22,3.22,0,0,1,168.29,194.2Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,199.6l-9.73-.64,9.67-.48A5.79,5.79,0,0,1,173.81,199.6Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8,203.93a3,3,0,0,1-1.22,1.21,6.37,6.37,0,0,1-1.62.67l.12-.1c-.22.52-.46,1-.71,1.54l-.22-.24a1.93,1.93,0,0,1,1.56.28,2.44,2.44,0,0,1,.92,1.21,2.92,2.92,0,0,0-1-1,1.91,1.91,0,0,0-1.32-.16l-.37.1.15-.35c.23-.52.47-1,.72-1.54l0-.08.08,0a9,9,0,0,0,1.58-.55A3.58,3.58,0,0,0,172.8,203.93Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.32,205.34a29.51,29.51,0,0,1-3.48.46,3.78,3.78,0,0,1-1.08,1.93,20.39,20.39,0,0,1-1.77,1.69l2.64-.33s.58-1.23,2.94-1.84Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.32,213.46l-.8,3.49c-6.81,2.22-14,7.52-15.41,11.41C96,222.27,99.34,217.48,111.32,213.46Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.75,88.36l-1-.13c-3.34-.35-7.8-.43-10.5.46-3.47,1.16-4.68,2.44-6.71,2.49-2.19,0-3.65-1.23-7.75-2.33-3.33-.89-9-.73-13.5-.26l-1.43.16A2.25,2.25,0,0,0,140.2,91a4.85,4.85,0,0,0,1.34,2.61,3,3,0,0,1,.46,1.06c.47,1.84.73,5.43,1.67,7.41a8.94,8.94,0,0,0,1.84,2.64,6.72,6.72,0,0,0,.94.75,6.16,6.16,0,0,0,.55.33,7.63,7.63,0,0,0,1.61.67l.27.07c.14,0,.28.07.43.09l.44.08a10.25,10.25,0,0,0,1.41.13h.59l.75,0c5.62-.37,7.82-3.22,9.06-6s.72-6.45,3.1-6.51h.22a.71.71,0,0,1,.21,0c1.75.36,1.71,3.73,2.93,6.14a10.45,10.45,0,0,0,1.81,2.61c.14.14.27.27.42.4l.22.18.23.18.21.15.23.14.18.11.12.07a7,7,0,0,0,2.05.74l.18,0a9.47,9.47,0,0,0,2.42.1,6.51,6.51,0,0,0,6.28-5.13c.53-1.8.5-4.92.68-6.55a1.85,1.85,0,0,1,.3-.84,4.15,4.15,0,0,0,.71-2.34C184,89.33,183.32,88.43,182.75,88.36Zm-22.66,10a8.37,8.37,0,0,1-1.76,3.88h0a8,8,0,0,1-6,2.59,6.69,6.69,0,0,1-6.09-2.55c-.07-.09-.13-.19-.19-.28a2.11,2.11,0,0,1-.18-.27,1.74,1.74,0,0,1-.15-.26l-.13-.23-.09-.19a1.3,1.3,0,0,1-.08-.17c0-.09-.09-.18-.12-.27h0c-.12-.28-.22-.55-.31-.81,0,0,0,0,0,0-.05-.17-.1-.34-.14-.49s-.15-.56-.2-.79q0-.09,0-.15a.83.83,0,0,0,0-.15c-.43-1.94-.93-5.73.08-6.59s3.58-1.75,7.72-1.42l.44,0c.62.07,1.24.16,1.85.29l.72.16a16.42,16.42,0,0,1,1.79.54l.54.21.59.27.12.06a1.51,1.51,0,0,1,.22.11,3.75,3.75,0,0,1,1.2.93C160.62,93.85,160.47,96.24,160.09,98.33Zm21.39-1.65c-.14,1.36-.45,4.35-2.79,5.81a5.51,5.51,0,0,1-2.6.8,5.9,5.9,0,0,1-5.67-2.42l0,0-.11-.16c0-.07-.09-.13-.12-.19l-.07-.1-.16-.28-.17-.33c0-.06-.05-.11-.07-.17a.36.36,0,0,1,0-.09l-.06-.13a.76.76,0,0,1,0-.11,9.45,9.45,0,0,1-.44-1.34c-.5-2-.83-4.3-.2-5.41s3.22-2.31,5.7-2.67a13.62,13.62,0,0,1,1.6-.15h1.14l.26,0,.43.05c.28,0,.55.08.8.13l.19,0h.05l.12,0,.2,0,.23.08.38.15.07,0a3.34,3.34,0,0,1,.88.55C181.76,91.61,181.65,95,181.48,96.68Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.12,89.63,128.3,98A7.15,7.15,0,0,1,132,99.71l9.84-6.7Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.38,105.44l-7.8,3.91-2-12.4a3.45,3.45,0,0,1,1.24-2.43Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#f0997a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Video_Bar",
    "data-name": "Video Bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.33,205.79a1.17,1.17,0,0,0-.05-.27.07.07,0,0,0,0-.06,1.83,1.83,0,0,0-.06-.25,1.56,1.56,0,0,0-.17-.37.49.49,0,0,0-.1-.15.44.44,0,0,0-.08-.1.85.85,0,0,0-.19-.19l0,0a.89.89,0,0,0-.25-.14,2.09,2.09,0,0,0-1.94.24L82.36,288c-1.59.92-2.89,2.32-2.89,6.37v4.35a2,2,0,0,0,3,1.72l145-83.5a6.36,6.36,0,0,0,2.89-5v-5.77C230.35,206,230.34,205.9,230.33,205.79Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#455a64",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.47,300.41l-.11-.05-3-1.77a3.08,3.08,0,0,1-1.51-2.23c0-.14,0-.28,0-.42v-5.06a6,6,0,0,1,1-3.13l0,0,3.56,2.05a8.29,8.29,0,0,0-.94,4.21v4.66a2.13,2.13,0,0,0,.14.71A2,2,0,0,0,80.47,300.41Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238",
    opacity: 0.9,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4,204.24a2.07,2.07,0,0,0-1.94.25L82.36,288a6.16,6.16,0,0,0-.8.57,4.16,4.16,0,0,0-.48.46,4.06,4.06,0,0,0-.64.84l-3.63-2.08a7.34,7.34,0,0,1,.62-.82l.23-.25a1.75,1.75,0,0,1,.24-.23l.25-.21a3.71,3.71,0,0,1,.52-.36L223.78,202.4a2,2,0,0,1,2.09-.17C226.4,202.55,228.78,203.91,229.4,204.24Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#455a64",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.47,300.41l0,0Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#263238",
    opacity: 0.9,
    style: {
      isolation: "isolate"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M90.38,291.38v-3.55c0-.26.16-.53.32-.53l3.12,0c.21,0,.21.45,0,.69l-3.12,3.58C90.54,291.71,90.38,291.63,90.38,291.38Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M97.66,287.17v-3.54c0-.26.16-.53.32-.53l3.13,0c.2,0,.2.45,0,.68L98,287.33C97.82,287.51,97.66,287.43,97.66,287.17Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5,285.32h0c-.13.08-.24,0-.24-.18V281.5a.59.59,0,0,1,.24-.46h0c.13-.07.24,0,.24.18v3.64A.57.57,0,0,1,101.5,285.32Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7,293.5V290c0-.25-.16-.33-.32-.16l-3.12,3.58c-.21.24-.21.69,0,.69l3.12,0C86.54,294,86.7,293.76,86.7,293.5Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M82.86,296.08h0a.57.57,0,0,0,.24-.45V292c0-.17-.11-.25-.24-.18h0a.59.59,0,0,0-.24.46v3.64C82.62,296.08,82.73,296.16,82.86,296.08Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M223.32,212.47a.29.29,0,0,1-.28-.28v-1.62a.29.29,0,0,1,.14-.24l1.3-.75a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.38l-1.17.67v1.46A.28.28,0,0,1,223.32,212.47Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M226.86,210.42a.28.28,0,0,1-.28-.27V209l-.88.51a.28.28,0,0,1-.38-.1.27.27,0,0,1,.1-.37l1.3-.76a.34.34,0,0,1,.28,0,.28.28,0,0,1,.13.24v1.63A.27.27,0,0,1,226.86,210.42Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M225.56,214.24a.26.26,0,0,1-.24-.13.28.28,0,0,1,.1-.38l1.16-.67v-1.47a.28.28,0,0,1,.28-.27.27.27,0,0,1,.27.27v1.63a.27.27,0,0,1-.14.24l-1.3.75A.31.31,0,0,1,225.56,214.24Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M223.32,215.54a.33.33,0,0,1-.14,0,.29.29,0,0,1-.14-.24v-1.62a.29.29,0,0,1,.28-.28.28.28,0,0,1,.27.28v1.15l.89-.52a.28.28,0,1,1,.28.48l-1.3.75A.37.37,0,0,1,223.32,215.54Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M221.31,213.38l-.53.22a.05.05,0,0,1-.07,0,1.86,1.86,0,0,0-.13-.34s0-.11,0-.17l.3-.67c0-.06,0-.13,0-.15l-.42-.31s-.07,0-.11.09l-.36.6c0,.06-.09.11-.12.1a1.1,1.1,0,0,0-.31,0s-.06,0-.07-.06l-.05-.67s0-.05-.07,0l-.57.34a.14.14,0,0,0-.07.12l-.06.71a.33.33,0,0,1-.07.16,2.14,2.14,0,0,0-.28.32.22.22,0,0,1-.12.07l-.42-.21s-.07,0-.1.1l-.36.7c0,.06-.06.13,0,.15l.34.37a.23.23,0,0,1,0,.16c0,.14-.08.29-.11.43a.26.26,0,0,1-.09.15l-.51.37a.18.18,0,0,0-.06.13v.76c0,.05,0,.08.05.06l.53-.23a.07.07,0,0,1,.07,0,1.6,1.6,0,0,0,.14.35.3.3,0,0,1,0,.17l-.29.66c0,.07,0,.14,0,.14l.42.33s.06,0,.1-.09l.36-.6c0-.06.09-.11.12-.11a.65.65,0,0,0,.31,0,.07.07,0,0,1,.07.07l.06.66c0,.05,0,.06.07.05l.57-.34a.24.24,0,0,0,.07-.12l.05-.72a.37.37,0,0,1,.08-.15,2.85,2.85,0,0,0,.27-.32c.05-.05.09-.08.12-.07l.42.21s.07,0,.1-.1l.37-.7a.21.21,0,0,0,0-.16l-.34-.37a.19.19,0,0,1,0-.15,3.45,3.45,0,0,0,.12-.43.27.27,0,0,1,.08-.15l.51-.37a.17.17,0,0,0,.07-.14v-.76C221.37,213.38,221.34,213.36,221.31,213.38Zm-2.19,3c-.53.31-1,0-1-.73a2.35,2.35,0,0,1,1-1.86c.54-.3,1,0,1,.74A2.32,2.32,0,0,1,219.12,216.4Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M134.37,264.81V263l-27.49,15.88a1.89,1.89,0,0,0-.95,1.43c0,.48.42.63.95.33Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.29,218.13a1.07,1.07,0,0,0-.37.14L134.37,263v1.77L211.92,220a2.08,2.08,0,0,0,.68-.64,2.49,2.49,0,0,0,.2-.4,1.11,1.11,0,0,0,.07-.39A.44.44,0,0,0,212.29,218.13Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M135.75,263.25a3.32,3.32,0,0,1-1.38,2.63c-.76.43-1.37,0-1.37-1.05a3.28,3.28,0,0,1,1.37-2.62C135.13,261.77,135.75,262.23,135.75,263.25Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.75,263.25a3.32,3.32,0,0,1-1.38,2.63c-.76.43-1.37,0-1.37-1.05a3.28,3.28,0,0,1,1.37-2.62C135.13,261.77,135.75,262.23,135.75,263.25Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M135.26,263.53a2.15,2.15,0,0,1-.89,1.7c-.49.28-.89,0-.89-.68a2.12,2.12,0,0,1,.89-1.69C134.86,262.58,135.26,262.88,135.26,263.53Z",
    transform: "translate(-11.49 -43.64)",
    fill: "#ba68c8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDc31);
export default __webpack_public_path__ + "static/media/dc3_1.5364c86b49e56ee41f400934ebba18f5.svg";
export { ForwardRef as ReactComponent };